import { createApp } from 'vue'
import TeikibinAccordion from '~/js/components/teikibinAccordion'

const CLASS_NAME_TEIKIBIN_QA = 'js-teikibin-qa'
const CLASS_NAME_TEIKIBIN_QA_BLOCK = 'js-teikibin-qa-block'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinQa = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_QA
  )
  if (!elementsTeikibinQa.length) return
  Array.from(elementsTeikibinQa).forEach((element) => {
    const elementsTeikibinQaBlock = element.getElementsByClassName(
      CLASS_NAME_TEIKIBIN_QA_BLOCK
    )
    const blocks = Array.from(elementsTeikibinQaBlock).map((blockElement) => {
      const title = blockElement.querySelector('h3')?.innerText
      const id = blockElement.id
      return { title, id }
    })

    createApp({
      components: {
        TeikibinAccordion,
      },
      data() {
        return {
          blocks,
        }
      },
    }).mount(element)
  })
})
